import { DataService } from "@/services/data";
import { isFeatureEnabled } from "@/utils/feature-flag";
import { RouteObject } from "react-router-dom";

const ApprenticeshipMapRoute: RouteObject = {
    path: "carte",
    children: [
        {
            index: true,
            async lazy() {
                let { MapV2Page } = await import("@/pages/apprenticeship/map-v2");
                return { Component: MapV2Page };
            },
            loader: async ({ request }) => {
                const url = new URL(request.url);
                const searchParams = new URLSearchParams(url.searchParams);
                if (isFeatureEnabled("apprenticeship-standard-map")) {
                    searchParams.set("source", "sf");
                }

                const withParams = (basePath: string, extra?: Record<string, string>) => {
                    const params = new URLSearchParams(searchParams);
                    if (extra) {
                        Object.entries(extra).forEach(([key, value]) => params.set(key, value));
                    }
                    const query = params.toString();
                    return query ? `${basePath}?${query}` : basePath;
                };

                const candidates = DataService.client.url(withParams("/apprenticeship/map/candidates/")).get().json();
                const companies = DataService.client
                    .url(withParams("/apprenticeship/map/companies/", { all: "true" }))
                    .get()
                    .json();
                const offer_ads = DataService.client
                    .url(withParams("/apprenticeship/map/offer_ads/", { all: "true" }))
                    .get()
                    .json();

                return { candidates, companies, offer_ads };
            }
        }
    ]
};

export default ApprenticeshipMapRoute;
